import React from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';

/**
 * Error component to display error messages.
 *
 * @param {object} props
 * @param {object} [props.message=null] - The error object containing the message.
 * @param {string|null} [props.className=null] - Additional class name(s) for styling.
 * @returns {JSX.Element|null} The error message element or null.
 */
const ErrorMsg = ({ message = null, className = null }) => (
  message ? (
    <div
      className={cx(
        styles.errorMessage,
        { [className]: className },
      )}
      data-testid="error-message"
    >
      {message}
    </div>
  ) : null
);

export { ErrorMsg };
